import { WorkTitleOption } from "../../../../../hooks/useWorkTitleAutocomplete";

export type WorkTitleValue = Pick<WorkTitleOption, "id" | "name"> &
  Partial<Pick<WorkTitleOption, "fieldOfWork">>;

const mergeWorkTitleValue = (
  value: WorkTitleValue,
  option?: WorkTitleOption,
): WorkTitleOption => {
  if (!option) {
    return {
      id: value.id,
      name: value.name,
      fieldOfWork: value.fieldOfWork || "",
    };
  }

  return {
    ...option,
    name: option.name || value.name,
    fieldOfWork: option.fieldOfWork || value.fieldOfWork || "",
  };
};

export const dedupeWorkTitleValues = (
  values: WorkTitleValue[],
): WorkTitleValue[] => {
  const seenIds = new Set<string>();

  return values.filter((value) => {
    if (seenIds.has(value.id)) return false;
    seenIds.add(value.id);
    return true;
  });
};

export const normalizeSelectedWorkTitleValues = (
  values: WorkTitleValue[] | undefined,
  options: WorkTitleOption[],
): WorkTitleOption[] => {
  if (!values?.length) return [];

  return dedupeWorkTitleValues(values).map((value) =>
    mergeWorkTitleValue(
      value,
      options.find((option) => option.id === value.id),
    ),
  );
};
